<template>
  <div>
    <h2><a target="_blank" :href="url">{{ row.title }}</a>

      <Tooltip content="点击复制活动链接" placement="bottom">
        <Icon type="ios-copy-outline" @click="copyUrl" class="icon-tag" style="margin-bottom: 7px;"/>
      </Tooltip>
    </h2>
    <!--<p>-->
      <!--<Icon type="ios-time-outline"> </Icon> 活动时间：{{ formatDate(row.startDate) }} ~ {{ formatDate(row.endDate) }}-->
    <!--</p>-->

    <!--<p>-->
      <!--<Icon type="ios-location"></Icon> 活动地点：{{ row.addressDetail }}-->
    <!--</p>-->
    <p v-if="row.status !== 0">
      <Icon type="ios-person-outline"></Icon> 发布者：{{ row.publishUser ? row.publishUser.nickname : '' }}{{ row.publishDate ? '（' + formatDate(row.publishDate) + '）' : ''}}
    </p>
    <p v-if="row.status !== 0">
      <Icon type="ios-home-outline"></Icon> 发布机构：{{ row.org ? row.org.orgName: '--' }}
    </p>
    <p v-if="row.status === 0">
      <Icon type="ios-person-outline"></Icon> 创建者：{{ row.creatorUser ? row.creatorUser.nickname : '' }}{{ row.createDate ? '（' + formatDate(row.createDate) + '）' : ''}}
    </p>
    <p v-if="row.hidden">
      <Icon type="ios-pricetags" /> 发布类型：
      <Badge text="定向发布" type="warning"></Badge>
    </p>
    <p >
      <Icon type="ios-alarm"></Icon> 报名截止：
      <span v-if="row.signSetting && row.signSetting.signEndDate">
        {{ row.signSetting.signEndDate ? formatDate(row.signSetting.signEndDate) : '未设置' }}
      </span>
      <span v-else>
        未设置
      </span>
    </p>
    <p v-if="row.status !== 0">
      <Icon type="ios-person-outline"></Icon> 浏览：{{ row.visitCount }} &nbsp;&nbsp;&nbsp;&nbsp;  报名：{{ row.signInCount }}
    </p>
    <!--<h4 style="margin-top: 10px">-->
      <!--<router-link :to="`/meetings/${row.id}/detail`" class="operation"><Icon type="ios-list-outline"></Icon> 基本信息</router-link>-->
      <!--<router-link :to="`/meetings/${row.id}/sign/setting`" class="operation"><Icon type="ios-gear-outline"></Icon> 设置报名项</router-link>-->
      <!--<router-link :to="`/meetings/${row.id}/signs`" class="operation"><Icon type="ios-person-outline"></Icon> 参会者管理</router-link>-->
    <!--</h4>-->
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import Clipboard from 'clipboard'

export default {
  name: 'MeetingInfoCell',
  props: {
    row: Object
  },
  computed: {
    url () {
      let host
      if (Vue.config.productionTip) {
        host = 'https://bizevent.ccpit.org/'
      } else {
        host = 'http://localhost:8081/'
      }

      return `${host}meetings/${this.row.id}` + (this.row.status === 0 ? `?pc=${this.row.previewCode}` : '')
    }
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm')
      } else {
        return null
      }
    },
    copyUrl () {
      let host
      if (Vue.config.productionTip) {
        host = 'https://bizevent.ccpit.org/'
      } else {
        host = 'http://localhost:8081/'
      }
      const clipBoardContent = `${host}meetings/${this.row.id}` + (this.row.status === 0 ? `?pc=${this.row.previewCode}` : '')
      let clipboard = new Clipboard('.icon-tag', {
        text: function () {
          return clipBoardContent
        }
      })
      clipboard.on('success', e => {
        this.$Message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$Message.error('复制失败')
        clipboard.destroy()
      })
    }
  }
}
</script>

<style scoped="scope" scss>
  .operation {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/components/MeetingInfoCell.vue